import { useCallback, useEffect, useRef, useState } from 'react';
import { useDidUpdate } from './useDidUpdate';

export function useLatencyIdle(timeout: number, state, initialState) {
    const [tickerIdle, setTickerIdle] = useState<boolean>(initialState);
    const timer = useRef<NodeJS.Timeout>();

    const handleEvents = useCallback(() => {
        if (timer.current) {
            setTickerIdle(false);
            clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                setTickerIdle(true);
            }, timeout);
        }
    }, [timer.current]);

    useDidUpdate(() => {
        handleEvents();
    }, [state]);

    useEffect(() => {
        timer.current = setTimeout(() => {
            setTickerIdle(true);
        }, timeout);

        return () => {
            if (timer.current) {
                clearTimeout(timer.current);
            }
        };
    }, []);

    return tickerIdle;
}
